module.exports = __webpack_public_path__ + "img/sequence-finder-logo.b4823831.svg";